import BuyCredit from './BuyCredit'

export default BuyCredit
